import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {setPasswordFormServerError} from "../common-states/commonStatesSlice";

const config = {
    headers: { Authorization: `Token ${localStorage.getItem("token")}` },
};
export const postTopMenuPasswordForm = createAsyncThunk("topMenu/postTopMenuPasswordForm", async(allData) => {
    const {data, dispatch} = allData
    const userId = localStorage.getItem('userId')
    await axios.post('https://api.khedmatashayer-kj.ir/v1/user/password', {
        ...data, user_id: userId
    }, config)
        .then(res => {
            alert(res.data.message)
        })
        .catch(err => {
            alert('با خطا مواجه شد!')
            dispatch(setPasswordFormServerError(err.response.data.message))
        })
})

const topMenuSlice = createSlice({
    name: 'topMenu',
    initialState: {
        showTopMenuPasswordForm: false
    },
    reducers: {
        handleShowTopMenuPasswordForm: (state, action) => {
            state.showTopMenuPasswordForm = action.payload
        }
    },
})

export const {handleShowTopMenuPasswordForm} = topMenuSlice.actions
export const selectShowTopMenuPasswordForm = state => state.topMenu.showTopMenuPasswordForm
export default topMenuSlice.reducer